const highlighterTokenSets = [
  { class: 'bg-primary', style: 'color:white' },
  { class: 'bg-accent', style: 'color:white' },
  { class: 'bg-positive', style: 'color:white' },
  { class: 'bg-info', style: 'color:white' },
  { class: 'bg-negative', style: 'color:white' },
  { class: 'bg-secondary', style: 'color:white' },
  { class: 'bg-warning', style: 'color:white' }
]

const highlighterTokenSetLength = highlighterTokenSets.length
const getTokenSet = (index) => {
  return highlighterTokenSets[index % highlighterTokenSetLength]
}

export default function highlighter (stack, needleArg, splitter) {
  if (!stack) return `<span>undefined</span>`

  const _needle = (needleArg || '').toLowerCase()
  if (_needle === '') return `<span>${stack}</span>`

  let needles = []
  if (splitter) needles = _needle.split(splitter)
  else needles = [_needle]

  let result = stack
  let i = -1
  for (const needle of needles) {
    i++
    const start = result.toLowerCase().indexOf(needle)

    if (start > -1) {
      const tokenSet = getTokenSet(i)
      let res = '<span>'
      res += '<span>' + result.substring(0, start) + '</span>'
      res += `<span class="${tokenSet.class}" style="${tokenSet.style}">` + result.substring(start, start + needle.length) + '</span>'
      res += '<span>' + result.substring(start + needle.length, result.length) + '</span>'
      res += '</span>'
      result = res
    }
  }

  return result
}
